import { FormEvent } from 'react';
import { CompanyQrcode } from '../../types/qrcode';
import { Form, FormField, FormLabel, FormInput, FormSelect, FormCheckbox, Button } from '../ui';

interface QrcodeFormProps {
  qrcode: CompanyQrcode | null;
  promotionCompanies: any[];
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  onClose: () => void;
}

function QrcodeForm({ qrcode, promotionCompanies, onSubmit, isLoading, onClose }: QrcodeFormProps) {
  return (
    <Form onSubmit={onSubmit}>
      <FormField>
        <FormLabel htmlFor="promotion_company_id" required>
          Empresa da Promoção
        </FormLabel>
        <FormSelect
          id="promotion_company_id"
          name="promotion_company_id"
          defaultValue={qrcode?.promotion_company_id}
          required
        >
          <option value="">Selecione uma empresa da promoção</option>
          {promotionCompanies.map(pc => (
            <option key={pc.id} value={pc.id}>
              {pc.promotion_name} - {pc.company_name}
            </option>
          ))}
        </FormSelect>
      </FormField>

      <FormField>
        <FormLabel htmlFor="qr_date" required>
          Data
        </FormLabel>
        <FormInput
          type="date"
          id="qr_date"
          name="qr_date"
          defaultValue={
            qrcode?.qr_date ? new Date(qrcode.qr_date).toISOString().split('T')[0] : undefined
          }
          required
        />
      </FormField>

      <FormField>
        <FormLabel htmlFor="coupon_quantity" required>
          Quantidade de Cupons
        </FormLabel>
        <FormInput
          type="number"
          id="coupon_quantity"
          name="coupon_quantity"
          min="1"
          defaultValue={qrcode?.coupon_quantity || 1}
          required
        />
      </FormField>

      <FormField>
        <div className="flex items-center">
          <FormCheckbox id="send" name="send" defaultChecked={qrcode?.send || false} />
          <FormLabel htmlFor="send" className="ml-2 mb-0">
            Enviado
          </FormLabel>
        </div>
      </FormField>

      {qrcode?.qr_url && (
        <FormField>
          <FormLabel>QR Code</FormLabel>
          <div className="flex justify-center p-4 bg-white border rounded-lg">
            <img src={qrcode.qr_url} alt="QR Code" className="max-w-full h-auto max-h-64" />
          </div>
          <div className="mt-2 text-center">
            <a
              href={qrcode.qr_url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 hover:text-primary-700 text-sm"
            >
              Abrir em nova janela
            </a>
          </div>
        </FormField>
      )}

      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Button type="submit" isLoading={isLoading} className="sm:col-start-2">
          {qrcode ? 'Salvar' : 'Criar'}
        </Button>
        <Button type="button" variant="secondary" onClick={onClose} className="sm:col-start-1">
          Cancelar
        </Button>
      </div>
    </Form>
  );
}

export default QrcodeForm;
